import type { ApiResponse } from '@creator/sdk/creator-sdk';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';
import type { Post } from '@src/store/contentEntities/model';
import { purgePostCache } from './common/cache';
import { setPost } from './posts';

export const MIN_CHARS_TO_SYNDICATE = 500;

export interface SyndicatePostApiRequestPayload {
    userId: string;
    postId: string;
    tokenName: string;
    syndicate: boolean;
}

export const syndicatePost = async (payload: SyndicatePostApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Post>>(
        '/post/syndicate',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false
    );

    const post = data.payload;
    purgePostCache(post);
    // Update postsAtom using Immer draft mutation
    setPost(post);

    return post;
};
